<!-- /src/components/common/Sort.vue -->
<template>
  <div class="header_sort_filter form__control">
    <div class="sort_filter" :class="'sort_filter--' + sortOptions.type">
      <div
        class="sort_filter__label"
        :class="{ 'sort_filter__label--active': selectVisible }"
        @click="selectVisible = !selectVisible"
      >
        <span class="sort_filter__label__pre_text">Sort By:</span>
        <span class="sort_filter__label__text">{{ activeOptionName }}</span>
        <span class="sort_filter__label_icon"
          ><i class="sort_filter__label_icon__icon fal fa-angle-right"></i
        ></span>
      </div>
      <transition name="dropdown">
        <ul class="sort_filter__options" v-if="selectVisible">
          <li
            v-for="(option, index) in sortOptions.options"
            class="sort_filter__options__item"
            :class="{
              'sort_filter__options__item--active': option.name == activeOptionName,
            }"
            :key="'sortOption_' + index"
            @click="changeOption(option)"
          >
            {{ option.name }}
          </li>
        </ul>
      </transition>
    </div>
  </div>
</template>

<script>
import defaults from 'lodash/defaults'
import { deepSearch } from '@/components/common/utils/helpers.js'

export default {
  data() {
    return {
      selectVisible: false,
      activeOptionName: '',
      sortOptions: {
        type: 'select',
        key: 'sort',
        label: 'Sort',
        options: [
          {
            id: '-date',
            name: 'Most Recent',
            active: false,
          },
          {
            id: 'date',
            name: 'Oldest',
            active: false,
          },
          {
            id: 'post_title',
            name: 'Title (A-Z)',
            active: false,
          },
          {
            id: '-post_title',
            name: 'Title (Z-A)',
            active: false,
          },
          {
            id: 'default',
            name: 'Default',
            active: true,
          },
        ],
      },
    }
  },

  props: {
    defaultSort: {
      type: String,
      required: false,
    },
  },

  sort_filters: {
    optionLabel(option) {
      return option.name
    },
  },
  computed: {
    sort_filterHasOptions() {
      const { options } = this
      const optionList = deepSearch(options, ['options'])

      return Array.isArray(optionList) ? optionList.length > 0 : false
    },
  },

  methods: {

    setActiveByID(id) {
      const { sortOptions } = this
      let currentActive = sortOptions.options.find(ele => ele.active == true)
      if (id !== undefined) {
        currentActive.active = false
        currentActive = sortOptions.options.find(ele => ele.id == id)
        currentActive.active = true
      } 
      this.activeOptionName = currentActive.name
    },

    changeOption(option) {
      this.selectVisible = !this.selectVisible
      this.mkRouteObj(option)
    },

    mkRouteObj(option) {
      this.setActiveByID(option.id)
      const queryModifier = {}
      const { id } = option
      const { name } = this.$route
      const key = this.sortOptions.key
      let { ...query } = this.$route.query
      // console.log(option)
      queryModifier['page'] = 1
      if ((typeof query[key] != 'undefined' && query[key] == id) || id == 'default') {
        delete query[key]
      } else {
        queryModifier[key] = id
      }
      query = Object.assign(defaults(queryModifier, query))
      this.$router.push({
        name,
        query,
      })
    },

    updateSearchValue(e) {
      this.search = e.target.value
    },

    optionActive(option) {
      const { ...query } = this.$route.query
      const { id } = option
      const key = this.sortOptions.key
      if (typeof query[key] != 'undefined' && query[key] == id) {
        return true
      } else {
        return false
      }
    },
  },
  mounted() {
    if (this.$route.query && this.$route.query.search) {
      this.search = this.$route.query.search
    }
  },
  beforeMount() {
    this.setActiveByID(this.$route.query.sort)
  },
}
</script>

<style scoped>
.sort_filter {
  font-size: 0.6rem;
  box-sizing: border-box;
  position: relative;

  &__label {
    /* display: inline-block; */
    position: relative;
    border: 0;
    color: var(--brandPrimary);
    margin-bottom: 4px;
    cursor: pointer;
    transition: all var(--animationDurationShort) ease;
    font-size: 1.2em;
    display: grid;
    grid-template-columns: auto auto auto;
    align-items: center;
    grid-gap: 0.25rem;

    &__text {
      display: inline-block;
      font-weight: var(--fontWeightExtraBold);
    }

    &__pre_text {
      font-style: italic;
    }

    &_icon {
      display: inline-block;
      position: relative;
      background-color: var(--gray);
      height: 25px;
      width: 25px;
      border-radius: 50%;
      z-index: 1;
      line-height: 1;
      transition: transform var(--animationDurationShort) ease;

      &__icon {
        color: white;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(0deg);
        font-size: 1.3rem;
        transition: transform var(--animationDurationShort) ease;
      }
    }

    &--active {
      .sort_filter__label_icon__icon {
        transform: translate(-50%, -50%) rotate(90deg);
      }
    }
  }

  &__options {
    margin: 0;
    font-weight: var(--fontWeightExtraBold);
    text-transform: uppercase;

    cursor: pointer;
    position: absolute;
    right: 0;
    left: 0;
    z-index: 2;

    &__item {
      background-color: var(--gray);
      color: white;
      margin: 0;
      padding: 0.4rem 1rem 0.4rem 0.5rem;
      border-bottom: solid var(--lightGray) 1px;
      transition: background 500ms;

      &:hover {
        background-color: var(--brandAccent);
        color: white;
      }

      &:first-child {
        border-top-left-radius: var(--borderRadiusSmall);
        border-top-right-radius: var(--borderRadiusSmall);
      }

      &:last-child {
        border-bottom-left-radius: var(--borderRadiusSmall);
        border-bottom-right-radius: var(--borderRadiusSmall);
        border-bottom-width: 0;
      }

      svg {
        display: none;
      }

      &--active {
        color: white;
        background-color: var(--brandAccent);
        position: relative;
        cursor: default;

        &:hover {
          background-color: var(--brandAccent);
        }

        svg {
          display: block;
          position: absolute;
          right: 0.5rem;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
  }
}

a {
  display: block;
}

.select-enter-active,
.select-leave-active {
  transition: max-height 0.5s ease;
  will-change: max-height;
  overflow: hidden;
  max-height: 500px;
}

.select-enter,
.select-leave-to {
  max-height: 0;
}
</style>
